// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
Array.prototype.pluck = function <T>(key: string): T[] {
  if (!Array.isArray(this)) {
    throw new TypeError("pluck must be called on an Array.");
  }
  return this.map((item) => item?.[key]);
};

export {};
